export const getValue = (selector) => document.querySelector(selector).value;

export default getValue;